import React from "react";
import "./index.css";

function BorderButton({ onClick, name = "Press Me", }) {
  const link = "https://drive.google.com/file/d/16AOlA3C_HzFD6_z3pStiLgVX931QLPs1/view?usp=drive_link";
  return (
    <>
      <div className="border-button" onClick={onClick} style={{ height: "3rem" }}>
        <a href={link}  target="_blank" rel=" noreferrer">
          <p className="text-1xl">{name}</p>
        </a>
      </div>
    </>
  );
}

export default BorderButton;
